import { Loader } from "@core/components";
import { createContext, PropsWithChildren } from "react";

import { useAuth0Token } from "./hooks";

export type Auth0ContextProps = {
  getToken: () => Promise<string | undefined>;
};

export const Auth0Context = createContext<Auth0ContextProps>({
  getToken: async () => undefined,
});

export const Auth0Provider = ({ children }: PropsWithChildren) => {
  const { auth0AccessToken, getToken } = useAuth0Token();

  if (!auth0AccessToken) {
    return <Loader fullScreen />;
  }

  return (
    <Auth0Context.Provider value={{ getToken }}>
      {children}
    </Auth0Context.Provider>
  );
};
